import { executeReport, REPORT_TYPES } from '../../../../../../../../../logic/utils/reportRequest';

export default async function SqlQuery(ticketId) {
  // Получаем данные через новый API
  const result = await executeReport(REPORT_TYPES.TICKET_REPORT_EXPAND, { ticketId });

  // Сортируем по row_id
  const dataObjects = result.dataObjects.sort((a, b) => a.row_id - b.row_id);

  // Возвращаем в обоих форматах для совместимости
  return { myData: dataObjects, dataObjects, query: result.query };
}
